/** Root URL prefix for the customer-facing app (no trailing slash). */
export const APP_BASE_PATH = "/facility";

/** Vite `base` option value (with trailing slash). */
export const VITE_BASE = `${APP_BASE_PATH}/`;

export function withAppBasePath(path: string): string {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  if (normalized === "/") return `${APP_BASE_PATH}/`;
  return `${APP_BASE_PATH}${normalized}`;
}

export function stripAppBasePath(pathname: string): string {
  if (pathname === APP_BASE_PATH || pathname === `${APP_BASE_PATH}/`) {
    return "/";
  }
  if (pathname.startsWith(`${APP_BASE_PATH}/`)) {
    return pathname.slice(APP_BASE_PATH.length) || "/";
  }
  return pathname;
}

export function getAppOriginUrl(): string {
  const origin = (globalThis as { location?: { origin: string } }).location?.origin;
  if (!origin) return APP_BASE_PATH;
  return `${origin}${APP_BASE_PATH}`;
}
